// Copyright © 2023 CATTLEytics Inc.

export enum TaskPeriod {
  Daily = 'daily',
  Weekly = 'weekly',
  Whenever = 'whenever',
}
